(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aj-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var burger = document.getElementById('ajBurger');
    var menu = document.getElementById('ajMobileMenu');
    var closeBtn = document.getElementById('ajMobileMenuClose');
    if (!burger || !menu) return;
    function openMenu() { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); burger.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
    function closeMenu() { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); burger.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); menu.querySelectorAll('.ajm-item.is-open').forEach(function(i){ i.classList.remove('is-open'); }); }
    burger.addEventListener('click', function(){ menu.classList.contains('is-open') ? closeMenu() : openMenu(); });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    menu.querySelectorAll('.ajm-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (link.classList.contains('has-sub')) { e.preventDefault(); link.closest('.ajm-item').classList.toggle('is-open'); }
        else { closeMenu(); }
      });
    });
    menu.querySelectorAll('.ajm-sub a, .aj-mobile-menu__bottom a').forEach(function(a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu(); });
  })();
  (function() {
    var badge = document.querySelector('.aj-nav__cartcount');
    if (!badge) return;
    function sync() { var n = parseInt(badge.textContent, 10) || 0; badge.style.display = n > 0 ? 'flex' : 'none'; }
    sync();
    if (window.MutationObserver) { new MutationObserver(sync).observe(badge, { childList: true, characterData: true, subtree: true }); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aj-journey"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.aj-journey');

    sections.forEach(function(section) {
      var steps = section.querySelectorAll('[data-journey-step]');
      var track = section.querySelector('.aj-journey__track');
      var fill = section.querySelector('.aj-journey__line-fill');
      if (!steps.length || !track || !fill) return;

      // Reveal each step as it enters the viewport
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

        steps.forEach(function(step) { observer.observe(step); });
      } else {
        steps.forEach(function(step) { step.classList.add('is-revealed'); });
      }

      // Draw the centre line in proportion to scroll progress through the track
      function updateLine() {
        var rect = track.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        // 0 when the track top reaches the viewport middle, 1 when its bottom does
        var start = vh * 0.5;
        var progress = (start - rect.top) / rect.height;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        fill.style.height = (progress * 100) + '%';
      }

      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            updateLine();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateLine);
      updateLine();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aj-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function reveal(root){
      var items = (root || document).querySelectorAll('.ajtw-reveal:not(.is-in)');
      if(!('IntersectionObserver' in window)){
        items.forEach(function(el){ el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function(el){ io.observe(el); });
    }
    if(document.readyState !== 'loading'){ reveal(); }
    else { document.addEventListener('DOMContentLoaded', function(){ reveal(); }); }
    document.addEventListener('shopify:section:load', function(e){ reveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
